import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import {
  PATIENT_API,
  AuthRequest,
  TokenResponse,
  IPatientTokenPayload
} from '@care-portals/api-interfaces';
import { getDomainFromLocation } from '@care-portals/shared';
import { environment } from '../../environments/environment';
import { AppFacade } from '../+store/app/app.facade';

const COOKIE_TOKEN_KEY = 'care-portals-patient';
const COOKIE_REFERRER_KEY = 'care-portals-patient-referrer';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  organization: string;

  constructor(
    public http: HttpClient,
    public router: Router,
    public cookie: CookieService,
    private appFacade: AppFacade
  ) {
    this.appFacade.layout$.subscribe(
      res => (this.organization = res.organization)
    );
  }

  public login(authRequest: AuthRequest): Observable<TokenResponse> {
    try {
      return this.http.post<TokenResponse>(
        environment.api.baseUrl +
          PATIENT_API.auth.base +
          PATIENT_API.auth.login,
        authRequest
      );
    } catch (error) {
      console.error(error);
      throw new Error('Failed to login: ' + error);
    }
  }

  public loginWithVerifyLink(token: string): Observable<TokenResponse> {
    try {
      return this.http.post<TokenResponse>(
        environment.api.baseUrl +
          PATIENT_API.auth.base +
          PATIENT_API.auth.loginWithVerifyLink,
        { token }
      );
    } catch (error) {
      console.error(error);
      throw new Error('Failed to login: ' + error);
    }
  }

  logout() {
    this.cookie.set(this.getCookieKey(), '', -1, '/', getDomainFromLocation()); // need this because delete sometimes is not working

    return true;
  }

  public saveToken(token: string): void {
    const payload: IPatientTokenPayload = this.decodeTokenPayload(token);
    const expiry = payload
      ? new Date(Number.parseInt(payload.exp, 10) * 1000)
      : 7;
    this.cookie.set(
      this.getCookieKey(),
      token,
      expiry,
      '/',
      getDomainFromLocation()
    );
  }

  public getToken(): string {
    return this.cookie.get(this.getCookieKey());
  }

  private decodeTokenPayload(token: string): IPatientTokenPayload {
    if (!token) return null;
    let payload = token.split('.')[1];
    payload = window.atob(payload);

    return JSON.parse(payload);
  }

  public saveReferrer(referrer: string) {
    this.cookie.set(
      this.getCookieReferrerKey(),
      referrer,
      1,
      '/',
      getDomainFromLocation()
    );
  }

  public getReferrer() {
    return this.cookie.get(this.getCookieReferrerKey());
  }

  private getCookieKey() {
    return `${COOKIE_TOKEN_KEY}-${this.organization}`;
  }

  private getCookieReferrerKey() {
    return `${COOKIE_REFERRER_KEY}-${this.organization}`;
  }

  // public getUserDetails(token?: String): Account {
  //   token = token || this.getToken();
  //   let payload;
  //   if (token) {
  //     payload = token.split('.')[1];
  //     payload = window.atob(payload);
  //     return JSON.parse(payload);
  //   } else {
  //     return null;
  //   }
  // }

  // get isLoggedIn():boolean{
  //   const user = this.getUserDetails();
  //   if (user) {
  //     return user.exp > Date.now() / 1000;
  //   } else {
  //     return false;
  //   }  }
}
